import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref, watch } from 'vue'
import * as vNG from 'v-network-graph'
import { ForceLayout } from 'v-network-graph/lib/force-layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeGraphComp',
  setup(__props) {

const nodeCount = ref(20)
const nodes = reactive({})
const edges = reactive({})

buildNetwork(nodeCount.value, nodes, edges)

watch(nodeCount, () => {
  buildNetwork(nodeCount.value, nodes, edges)
})

const configs = reactive(
  vNG.defineConfigs({
    view: {
      panEnabled: false,
      zoomEnabled: false,
      layoutHandler: new ForceLayout({
        positionFixedByDrag: false,
        positionFixedByClickWithAltKey: true
      })
    },
    node: {
      label: {
        visible: false
      }
    }
  })
)

function buildNetwork (count: number, nodes: vNG.Nodes, edges: vNG.Edges) {
  const idNums = [...Array(count)].map((_, i) => i)

  const newNodes = Object.fromEntries(idNums.map(id => [`node${id}`, {}]))
  Object.keys(nodes).forEach(id => delete nodes[id])
  Object.assign(nodes, newNodes)

  const makeEdgeEntry = (id1: number, id2: number) => {
    return [`edge${id1}-${id2}`, { source: `node${id1}`, target: `node${id2}` }]
  }
  const newEdges = Object.fromEntries([
    ...idNums
      .map(n => [n, (Math.floor(n / 5) * 5) % count])
      .map(([n, m]) => (n === m ? [n, (n + 5) % count] : [n, m]))
      .map(([n, m]) => makeEdgeEntry(n, m))
  ])
  Object.keys(edges).forEach(id => delete edges[id])
  Object.assign(edges, newEdges)
}

return (_ctx: any,_cache: any) => {
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createBlock(_component_v_network_graph, {
    class: "graph",
    "zoom-level": 0.5,
    nodes: nodes,
    edges: edges,
    configs: configs
  }, null, 8, ["zoom-level", "nodes", "edges", "configs"]))
}
}

})